document.documentElement.classList.remove('no-js');

const qs = (selector, root = document) => root.querySelector(selector);
const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];

function setExpanded(button, state) {
  if (button) button.setAttribute('aria-expanded', String(state));
}

// Mobile navigation
const menuButton = qs('[data-menu-toggle]');
const mobileNav = qs('[data-mobile-nav]');
const menuClose = qs('[data-menu-close]');
const menuOverlay = qs('[data-menu-overlay]');

function toggleMenu(force) {
  if (!mobileNav) return;
  const isOpen = typeof force === 'boolean' ? force : !mobileNav.classList.contains('is-open');
  mobileNav.classList.toggle('is-open', isOpen);
  menuOverlay?.classList.toggle('is-open', isOpen);
  document.body.classList.toggle('menu-open', isOpen);
  setExpanded(menuButton, isOpen);
  if (isOpen) menuClose?.focus();
}
menuButton?.addEventListener('click', () => toggleMenu());
menuClose?.addEventListener('click', () => toggleMenu(false));
menuOverlay?.addEventListener('click', () => toggleMenu(false));

// Header search
const searchButton = qs('[data-search-toggle]');
const searchPanel = qs('[data-search-panel]');
searchButton?.addEventListener('click', () => {
  const open = searchPanel?.hasAttribute('hidden');
  searchPanel?.toggleAttribute('hidden', !open);
  setExpanded(searchButton, open);
  if (open) qs('input[type="search"]', searchPanel)?.focus();
});

// Mobile collection filters
qsa('[data-filter-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const target = document.getElementById(button.getAttribute('aria-controls'));
    const open = !target?.classList.contains('is-open');
    target?.classList.toggle('is-open', open);
    setExpanded(button, open);
  });
});

// Product gallery
qsa('[data-gallery-thumb]').forEach((thumb) => {
  thumb.addEventListener('click', () => {
    const main = qs('[data-gallery-main]');
    const image = qs('img', thumb);
    if (!main || !image) return;
    main.src = thumb.dataset.imageUrl || image.src;
    main.alt = image.alt;
    qsa('[data-gallery-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
    thumb.setAttribute('aria-current', 'true');
  });
});

// Product variant selection
qsa('[data-product-section]').forEach((section) => {
  const select = qs('[data-variant-select]', section);
  const price = qs('[data-product-price]', section);
  const compare = qs('[data-product-compare]', section);
  const addButton = qs('[data-add-button]', section);
  const variantData = qs('[data-variant-json]', section);
  if (!select || !variantData) return;

  let variants = [];
  try { variants = JSON.parse(variantData.textContent); } catch (error) { return; }
  const moneyFormat = section.dataset.moneyFormat || '${{amount}}';
  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  select.addEventListener('change', () => {
    const variant = variants.find((item) => String(item.id) === select.value);
    if (!variant) return;
    if (price) price.textContent = formatMoney(variant.price);
    if (compare) {
      compare.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
      compare.hidden = !(variant.compare_at_price > variant.price);
    }
    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  });
});

// Auto-submit filters/sort
qsa('[data-auto-submit]').forEach((input) => {
  input.addEventListener('change', () => input.form?.submit());
});

// Escape key closes overlays
window.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') toggleMenu(false);
});

// Compact homepage inventory tabs
qsa('[data-inventory-tabs]').forEach((section) => {
  const tabs = qsa('[data-inventory-tab]', section);
  const panels = qsa('[data-inventory-panel]', section);

  const activateTab = (selectedTab) => {
    tabs.forEach((tab) => {
      const active = tab === selectedTab;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const active = panel.id === selectedTab.getAttribute('aria-controls');
      panel.classList.toggle('is-active', active);
      panel.toggleAttribute('hidden', !active);
    });
  };

  tabs.forEach((tab, index) => {
    tab.setAttribute('tabindex', index === 0 ? '0' : '-1');
    tab.addEventListener('click', () => activateTab(tab));
    tab.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let nextIndex = index;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      tabs[nextIndex].focus();
      activateTab(tabs[nextIndex]);
    });
  });
});
